// Italic Model Logic (IML)
export function iml($string) {
  let data = "";

  const storedTerms = [
    "Offer",
    "Festival",
    "Cuisine Privée",
    "Glamorous",
    "Celebration",
    "Hidden",
    "Cruising",
    "Festival",
    "Sampling",
    "Pearls",
    "Wonderful",
    "Sky",
    "Inclusive",
    "Quintessential",
    "Discovery Tour",
    "Deluxe",
    "Junior",
    "Romance",
    "Executive",
    "Panorama",
    "Designer",
    "One-Bedroom",
    "Two-Bedroom",
    "Royal",
    "Boutique",
    "The Long",
    "Cardinal",
    "Conferences",
    "Conference",
    "Weddings",
    "Ballroom",
    "San Carlo",
    "Jade & Amber",
    "Title",
  ];

  function filterIt(storedTerms, $string) {
    let result = "";
    let newStr = "";
    storedTerms.forEach((term) => {
      if ($string.includes(term)) {
        newStr = $string.split(term);
        result = newStr[0] + "<i>" + term + "</i>" + newStr[1];
      }
    });

    return result ? result : $string;
  }

  return filterIt(storedTerms, $string);
}
